import { render, staticRenderFns } from "./study-participant-edc-unscheduled-forms-reskin.vue?vue&type=template&id=85bb0f20&scoped=true&"
import script from "./study-participant-edc-unscheduled-forms-reskin.vue?vue&type=script&lang=js&"
export * from "./study-participant-edc-unscheduled-forms-reskin.vue?vue&type=script&lang=js&"
import style0 from "./study-participant-edc-unscheduled-forms-reskin.vue?vue&type=style&index=0&id=85bb0f20&scoped=true&lang=scss&"
import style1 from "./study-participant-edc-unscheduled-forms-reskin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bb0f20",
  null
  
)

component.options.__file = "study-participant-edc-unscheduled-forms-reskin.vue"
export default component.exports